import { BlogPostDto } from '@/components/BlogPage/types';

export const useBlogPost = (post: BlogPostDto) => {
	const href = `/blog/post/${post?.seo?.url}`;
	const cardTitle = post.preview?.title || post.title;

	const media = post.preview?.image ?? post.heroMedia;
	const isVideo = media && 'mime' in media && media.mime.startsWith('video');

	return {
		cardTitle,
		media,
		isVideo,
		href
	};
};
